
// top nav title
const TOP_NAV_TITLES = {
  it: 'IT',
  lastPageTitle: "HOME",
  fde_deo_distributor: 'Deo Distributor'
}

// side nav title
const SIDE_NAV_TITLES = {
  fundDayEndReport: 'Fund Day End Report',
  newSecurity: 'New Security'
}

// fde status label
const FDE_STATUS_LABEL = {
  NA: 'NA',
  Ready: 'Ready',
  NewSecurity: 'New Security',
  Fail: 'Fail'
}

// fde status value
const FDE_STATUS_VALUE = {
  NA: 'NA',
  Ready: 'Ready',
  NewSecurity: 'NewSecurity',
  Fail: 'Fail'
}

export {
  TOP_NAV_TITLES,
  SIDE_NAV_TITLES,
  FDE_STATUS_LABEL,
  FDE_STATUS_VALUE
};
